import { UID, getColumns } from "./common";

export default {
  columns: getColumns({
    header: "Billing management",
    subheader:
      "Allow your customers to easily cancel their subscriptions in one-click, directly from their receipt."
  }),
  rows: [
    {
      title: {
        value: "One click unsubscribe"
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    }
  ]
};
